import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { Asistente } from 'src/app/model/asistente';
import { AlertaService } from 'src/app/util/alerta.service';
import { ConfirmDialogComponent } from 'src/app/util/confirm-dialog/confirm-dialog.component';
import { ConfirmDialog } from 'src/app/util/confirm-dialog/confirmDialog';
import { functionUtil } from 'src/app/util/functionConst';
import { ParametrosConst } from 'src/app/util/parametrosConst';
import * as XLSX from 'xlsx';
import { IntranetService } from '../../intranet.service';
import { Asamblea } from '../../model/asamblea';
import { Parametro } from '../../model/parametro';
import { AsistenciaService } from './asistencia.service';
import { RegistroAsistenteDialogComponent } from './registro-asistente/registro-asistente-dialog.component';

@Component({
  selector: 'sura-asistencia',
  templateUrl: './asistencia.component.html',
  styleUrls: ['./asistencia.component.scss']
})
export class AsistenciaComponent implements OnInit, AfterViewInit {
  @ViewChild('TABLE', {static: false}) table: ElementRef;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  fnKeyDownNumeric = functionUtil.fnKeyDownNumeric;
  fnInputMaxLength = functionUtil.fnInputMaxLength;
  fnNumericMobile = functionUtil.fnNumericMobile;

  linkActive = '';
  newArrayAsistente: Asistente[] = [];
  newAsamblea: Asamblea = new Asamblea();
  porcentaje = '0.00';
  listTipoDocumento: Parametro[] = [];
  disableBtnAgregar = true;
  disableBtnEliminar = true;
  disabledBtnExcel = true;
  displayedColumns: string[] = ['VOTA', 'TIPO', 'NUMERODOCUMENTO', 'TITULAR', 'REPRESENTANTE', 'FECHA HORA', 'OPCIONES'];
  dataSource = new MatTableDataSource<Asistente>(this.newArrayAsistente);
  selection = new SelectionModel<Asistente>(true, []);
  nroAsambleaValidacion: FormControl = null;
  loading = -1;
  loadingBorrar = -1;

  constructor(private _asistenciaService: AsistenciaService,
              private _intranetService: IntranetService,
              private alertaService: AlertaService,
              public dialogRegistro: MatDialog,
              private router: Router) {
    this.linkActive = this.router.url;
    this.nroAsambleaValidacion = new FormControl('', [Validators.required,
      Validators.maxLength(6),
      Validators.pattern('[0-9]+')]);
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this._intranetService.obtenerParametro(ParametrosConst.TIPO_DOCUMENTO).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoDocumento = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  formatearCheckVoto(_asistenteROW: Asistente) {
    if (_asistenteROW.flagVoto === '1') {
      this.selection.select(_asistenteROW);
    } else {
      this.selection.deselect(_asistenteROW);
    }
  }

  toggleCheckVoto(_asistenteROW: Asistente, index) {
    const confirmDialog: ConfirmDialog = new ConfirmDialog();
    confirmDialog.message = _asistenteROW.flagVoto === '1' ? ParametrosConst.MSJ_DESACTIVAR_VOTO : ParametrosConst.MSJ_ACTIVAR_VOTO;
    confirmDialog.labelOk = _asistenteROW.flagVoto === '1' ? 'Desactivar' : 'Activar';
    const dialogRef = this.dialogRegistro.open(ConfirmDialogComponent, {
      width: '270px',
      data: confirmDialog,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result.flagRespuesta) {
        const newFlagVoto = _asistenteROW.flagVoto === '1' ? '0' : '1';
        this._asistenciaService.configurarPermisoVoto(_asistenteROW.id, newFlagVoto).then((resp: any) => {
          this.alertaService.success(resp.message);
          _asistenteROW.flagVoto = newFlagVoto;
          this.refrescarGrillaLocal(_asistenteROW, index);
        }).catch(err => {
          this.refrescarGrillaLocal(_asistenteROW, index);
          this.alertaService.error(err);
        });
      } else {
        this.refrescarGrillaLocal(_asistenteROW, index);
      }
    });

  }

  refrescarGrillaLocal(_asistenteROW: Asistente, index) {
    const copyArrayAsistente: Asistente[] = [];
    for (let ind = 0; ind < this.newArrayAsistente.length; ind++) {
      let newAsistenteCopy = new Asistente();
      newAsistenteCopy = this.newArrayAsistente[ind];
      copyArrayAsistente.push(newAsistenteCopy);
    }

    copyArrayAsistente[index] = _asistenteROW;
    this.newArrayAsistente.splice(0, this.newArrayAsistente.length);
    this.dataSource._updateChangeSubscription();

    for (let indice = 0; indice < copyArrayAsistente.length; indice++) {
      let newAsistente = new Asistente();
      newAsistente = copyArrayAsistente[indice];
      this.newArrayAsistente.push(newAsistente);
    }

    this.dataSource.data.forEach(row => {
      this.formatearCheckVoto(row);
    });
    this.dataSource._updateChangeSubscription();
  }

  getErrorMessageNroAsamblea() {
    return this.nroAsambleaValidacion.hasError('required') ? 'Campo Obligatorio ' :
      this.nroAsambleaValidacion.hasError('maxlength') ? 'Max 6 caracteres' :
        this.nroAsambleaValidacion.hasError('pattern') ? 'Solo se acepta números' :
          '';
  }

  limpiarComponentes() {
    this.limpiarGrillaAsistentes();
    this.newAsamblea.organizador.descripcion = '';
  }

  limpiarGrillaAsistentes() {
    this.newArrayAsistente.splice(0, this.newArrayAsistente.length);
    this.dataSource._updateChangeSubscription();
  }

  listarAsistentes() {
    this.limpiarGrillaAsistentes();
    this._asistenciaService.listarAsistente(this.newAsamblea.id).then(list => {
      if (list instanceof Array) {
        this.llenarGrillaAsistentes(list);
      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  porcentajeAsistentes() {

    this._asistenciaService.porcentajeAsistente(this.newAsamblea.id).then(result => {
      const res = +result;
      // const per = (res * 100).toFixed(2);
      this.porcentaje = (res * 100).toFixed(2);

    }).catch(err => {
      this.porcentaje = '0.00';
    });
  }


  llenarGrillaAsistentes(arrayResult) {
    this.selection.clear();
    this.newArrayAsistente.splice(0, this.newArrayAsistente.length);
    for (let index = 0; index < arrayResult.length; index++) {
      const newAsistente: Asistente = new Asistente();
      newAsistente.index = index;
      newAsistente.id = arrayResult[index].idAsistente;
      newAsistente.idFoto = arrayResult[index].idFoto;
      newAsistente.nombres = arrayResult[index].nombres;
      newAsistente.apellidos = arrayResult[index].apellidos;
      newAsistente.correo = arrayResult[index].correo;
      newAsistente.fechaRegistro = arrayResult[index].fechaRegistro;
      newAsistente.tipoDocumento = arrayResult[index].tipoDocumento;
      newAsistente.numeroDocumento = arrayResult[index].numeroDocumento;
      newAsistente.representante.descripcion = arrayResult[index].representante;
      newAsistente.tipoDocumentoR = arrayResult[index].tipoDocumentoR;
      newAsistente.numeroDocumentoR = arrayResult[index].numeroDocumentoR;
      newAsistente.tipo = arrayResult[index].tipo;
      newAsistente.tipoAsistente = arrayResult[index].tipoAsistente;
      newAsistente.usuarioRegistro = arrayResult[index].usuarioRegistro;
      newAsistente.flagVoto = arrayResult[index].flagVoto;
      newAsistente.factor = arrayResult[index].factor;
      newAsistente.cuotas = arrayResult[index].cuotas;
      newAsistente.idAsamblea = this.newAsamblea.id;
      this.newArrayAsistente.push(newAsistente);
    }
    this.dataSource.data.forEach(row => {
      this.formatearCheckVoto(row);
    });
    this.dataSource._updateChangeSubscription();
  }

  changeAsamblea() {
    this.disableBtnAgregar = true;
    this.disabledBtnExcel = true;
    this.newAsamblea.organizador.id = null;
    this.newAsamblea.organizador.descripcion = '';
    this.newAsamblea.estado = null;
  }

  buscarAsamblea() {
    this.porcentajeAsistentes();
    this.limpiarComponentes();
    this._intranetService.obtenerOrganizador(this.newAsamblea.id).then(resp => {
      this.newAsamblea.organizador.id = resp[0].idOrganizador;
      this.newAsamblea.organizador.descripcion = resp[0].organizador;
      this.newAsamblea.estado = resp[0].estadoAsamblea;
      if (resp[0].estadoAsamblea === '1') {
        this.disableBtnAgregar = false;
        this.disableBtnEliminar = false;
        this.listarAsistentes();
      } else {
        this.disableBtnAgregar = true;
        this.disableBtnEliminar = true;
        if (resp[0].messageWarn != null || resp[0].messageWarn !== '') {
          this.alertaService.warning(resp[0].messageWarn);
          setTimeout(() => {
            this.listarAsistentes();
          }, ParametrosConst.TIEMPO_DURACION_ALERTA_ANIDADO);
        } else {
          this.listarAsistentes();
        }
      }
      this.disabledBtnExcel = false;
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  openRegistroAsistente() {
    const dialogRegistroAsistente = this.dialogRegistro.open(RegistroAsistenteDialogComponent, {
      width: '600px',
      data: this.newAsamblea,
      disableClose: true
    });
    dialogRegistroAsistente.afterClosed().subscribe(after => {
      if (after != null) {
        const _newAsistente = new Asistente();
        _newAsistente.idAsamblea = this.newAsamblea.id;
        _newAsistente.idFoto = after.id;
        _newAsistente.tipoAsistente = after.tipoParticipante;
        _newAsistente.usuarioRegistro = 'ROOT';
        this.registrarAsistente(_newAsistente);
      }
    });
  }

  showEliminarAsistente(_dropAsistente: Asistente) {
    const confirmDialog: ConfirmDialog = new ConfirmDialog();
    confirmDialog.message = ParametrosConst.MSJ_ELIMINAR_ASISTENCIA;
    confirmDialog.labelOk = 'Eliminar';
    const dialogRef = this.dialogRegistro.open(ConfirmDialogComponent, {
      width: '270px',
      data: confirmDialog,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result.flagRespuesta) {
        this.eliminarAsistente(_dropAsistente);
      }
    });
  }

  eliminarAsistente(_dropAsistente: Asistente) {
    this.loadingBorrar = _dropAsistente.index;
    this._asistenciaService.eliminarAsistencia(
        this.newAsamblea.id, _dropAsistente.id, _dropAsistente.tipo.charAt(0), _dropAsistente.idFoto).then(respuesta => {
      const msg = respuesta['message'].split(/\|/)[0];
      this.alertaService.success(msg);
      _dropAsistente.id = 0;
      _dropAsistente.flagVoto = '0';
      _dropAsistente.fechaRegistro = null;
      this.formatearCheckVoto(_dropAsistente);
      this.newArrayAsistente[_dropAsistente.index] = _dropAsistente;
      this.porcentajeAsistentes();
      this.loadingBorrar = -1;
      if (_dropAsistente.tipo === 'Representante') {
        this.listarAsistentes();
      }
    }).catch(error => {
      this.alertaService.error(error);
      this.loadingBorrar = -1;
    });
  }

  registrarAsistente(_newAsistente: Asistente) {
    this._asistenciaService.manejarAsistencia(_newAsistente.idAsamblea, _newAsistente.idFoto,
      _newAsistente.tipoAsistente, _newAsistente.usuarioRegistro, 'A').then(success => {
      const msg = success['message'].split(/\|/)[0];
      this.alertaService.success(msg);
      this.listarAsistentes();
      this.porcentajeAsistentes();
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  registrarAsistenteInline(_newAsistente: Asistente) {
    const flagTitular = _newAsistente.tipo === 'Titular';
    if (flagTitular) {
      this.loading = _newAsistente.index;
      _newAsistente.tipoAsistente = 'T';
      _newAsistente.usuarioRegistro = 'ROOT';
      this._asistenciaService.manejarAsistencia(_newAsistente.idAsamblea, _newAsistente.idFoto,
        _newAsistente.tipoAsistente, _newAsistente.usuarioRegistro, 'A').then(success => {
        const rpta = success['message'].split(/\|/);
        this.alertaService.success(rpta[0]);
        _newAsistente.fechaRegistro = new Date();
        _newAsistente.flagVoto = '1';
        _newAsistente.id = rpta[1];
        this.formatearCheckVoto(_newAsistente);
        this.porcentajeAsistentes();
        this.loading = -1;
      }).catch(error => {
        this.alertaService.error(error);
        this.loading = -1;
      });
    } else {
        _newAsistente.idAsamblea = this.newAsamblea.id;
        _newAsistente.tipoAsistente = 'R';
        _newAsistente.usuarioRegistro = 'ROOT';
        this.registrarAsistente(_newAsistente);
    }
  }

  ExportTOExcel() {
    const arrayJsonExcel = [];
    const cantidad = this.newArrayAsistente.length;
    if (cantidad > 0) {
      for (let index = 0; index < cantidad; index++) {
        const asistente = this.newArrayAsistente[index];
        const jsonExcel = {};
        jsonExcel['TIPO DOCUMENTO TITULAR'] = asistente.tipoDocumento;
        jsonExcel['NÚMERO DOCUMENTO TITULAR'] = asistente.numeroDocumento;
        jsonExcel['NOMBRES TITULAR'] = asistente.nombres;
        jsonExcel['TIPO DOCUMENTO REPRESENTANTE'] = asistente.tipoDocumentoR;
        jsonExcel['NÚMERO DOCUMENTO REPRESENTANTE'] = asistente.numeroDocumentoR;
        jsonExcel['NOMBRES REPRESENTANTE'] = asistente.representante.descripcion;
        jsonExcel['FACTOR'] = asistente.factor;
        jsonExcel['CUOTAS'] = asistente.cuotas;
        jsonExcel['VOTA'] = asistente.flagVoto;
        jsonExcel['TIPO ASISTENTE'] = asistente.tipoAsistente;
        jsonExcel['FECHA HORA'] = asistente.flagVoto === '1' ? moment(new Date(asistente.fechaRegistro)).format('YYYY-MM-DD HH:mm') : '';
        jsonExcel['ASISTENCIA'] = asistente.fechaRegistro == null ? 'No' : 'Si';
        arrayJsonExcel.push(jsonExcel);
      }
      const wsJson: XLSX.WorkSheet = XLSX.utils.json_to_sheet(arrayJsonExcel);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, wsJson, 'Asistentes');
      XLSX.writeFile(wb, 'Asamblea - asistentes.xlsx');
    }
  }

  exportReportDetail(tipo) {
    this._asistenciaService.listarRespuesta(this.newAsamblea.id, tipo).then(list => {
      if (list instanceof Array) {
        const arrayJsonExcel = [];
        const cantidad = list.length;
        if (cantidad > 0) {
          for (let index = 0; index < cantidad; index++) {
            const respuesta = list[index];
            const jsonExcel = {};
            jsonExcel['TIPO DOCUMENTO'] = respuesta.tipoDocumento;
            jsonExcel['NÚMERO DOCUMENTO'] = respuesta.numeroDocumento;
            jsonExcel['PREGUNTA'] = respuesta.pregunta;
            jsonExcel['VOTO'] = respuesta.voto;
            if(tipo == 1) {
              jsonExcel['FECHA VOTO'] = respuesta.fechaVoto;
              jsonExcel['ASAMBLEA'] = this.newAsamblea.id;
            }
            arrayJsonExcel.push(jsonExcel);
          }
          const wsJson: XLSX.WorkSheet = XLSX.utils.json_to_sheet(arrayJsonExcel);
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, wsJson, 'Detalles');
          XLSX.writeFile(wb, tipo ==1 ? 'Asamblea - detalles - historico.xlsx' :'Asamblea - detalles.xlsx');
        }
      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

 

  ExportToPDF() {
    this._asistenciaService.reportePdf(this.newAsamblea.id).then(resp => {
      if (resp.size > 0) {
        saveAs(resp, 'Asamblea - asistentes.pdf');
      } else {
        this.alertaService.warning('No se pudo generar el reporte');
      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }
}
